import React from 'react'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next";

const Tr = (props) => {
    const { t } = useTranslation();

    const {shop} = useParams()

    const ship = props.ship;
    const  statusChangeHandler = props.statusChangeHandler;
    const isRestricted = props.isRestricted || false; // WAF制限状態

    const handleChange = (e) => {
        e.preventDefault();
        
        const isChecked = e.target.checked;
        props.onValueChange(ship.id, isChecked);
    };

    const RankList = () => {
        return ship.rank_array.map((rank, index) => {
            return (
                <span  key={"rank" + index}>
                    {rank == 9 ? <div className={`ship-rank ship-rank-${rank}`}>{t('tr.str1')}</div> : <div className={`ship-rank ship-rank-${rank}`}>{rank}</div>}
                </span>
            )
        })
    }

    const userId = (id) => {
        if(id === null || id === undefined) return '';
        return id;
    };

    const countries = {
        0: '日本',
        1: '台湾',
        2: '香港',
        3: 'シンガポール',
        4: 'アメリカ',
        5: 'カナダ',
        6: 'オーストラリア',
        7: 'ニュージーランド',
        8: 'イギリス',
        9: 'インド',
        10: 'マカオ',
        11: 'マレーシア',
    }

    // 個人情報制限時の表示処理
    const renderPersonalInfo = (data, fallback = '***') => {
        return isRestricted ? fallback : data;
    };

    const renderAddress = () => {
        if (isRestricted || ship.client_address === '***') {
            return '***';
        }

        const address = ship.client_address;
        if (!address) return '-';

        const addr = address['address'] || '';
        const addr2 = address['address2'] || '';
        return addr2 ? `${addr} ${addr2}` : addr;
    };

    const renderPostalCode = () => {
        if (isRestricted || ship.client_address === '***') {
            return '〒***-***';
        }
        
        const postalCode = ship.client_address?.['postal_code'];
        if (!postalCode) return '-';
        
        return postalCode.substr(3)[0] !== "-" 
            ? `〒${postalCode.substr(0,3)}-${postalCode.substr(3)}`
            : `〒${postalCode}`;
    };


    return (
    <>
        <tr>
            <td><input type="checkbox" name="ship" value={ship.id} checked={props.checkboxStates[ship.id] || false} onChange={handleChange}/></td>
            <td>{ship.id}</td>
            <td>{ship.order_date}</td>
            <td>{userId(ship.user_id)}</td>
            <td>{renderPersonalInfo(ship.client_name)}</td>
            <td>{isRestricted ? '***' : countries[ship.client_address['country']]}</td>
            <td>{renderPersonalInfo(ship.client_address['city'])}</td>
            <td>
                {!isRestricted && ship.client_address !== '***' && ship.client_address['country'] == 0 &&
                    <>
                        {ship.client_address['prefecture']}
                    </>
                }
                {(isRestricted || ship.client_address === '***') && '***'}
            </td>
            <td>{renderAddress()}</td>
            <td>{renderPostalCode()}</td>
            <td>
                <RankList/>
            </td>
            <td>
                {ship.status == 1 && <div className="ship-status ship-status-1" onClick={() => {statusChangeHandler(ship.id, ship.status)}}>{t('tr.status1')}</div>}
                {ship.status == 2 && <div className="ship-status ship-status-2" onClick={() => {statusChangeHandler(ship.id, ship.status)}}>{t('tr.status2')}</div>}
                {ship.status == 3 && <div className="ship-status ship-status-3" onClick={() => {statusChangeHandler(ship.id, ship.status)}}>{t('tr.status3')}</div>}
                {ship.status == 4 && <div className="ship-status ship-status-4" onClick={() => {statusChangeHandler(ship.id, ship.status)}}>{t('tr.status4')}</div>}
                {ship.status == 5 && <div className="ship-status ship-status-5" onClick={() => {statusChangeHandler(ship.id, ship.status)}}>{t('tr.status5')}</div>}
                {ship.status == 6 && <div className="ship-status ship-status-6" onClick={() => {statusChangeHandler(ship.id, ship.status)}}>{t('tr.status6')}</div>}
                {ship.status == 7 && <div className="ship-status ship-status-7" onClick={() => {statusChangeHandler(ship.id, ship.status)}}>{t('tr.status7')}</div>}
            </td>
            <td>
                <a href={`/${shop}/ship/${ship.id}`} target='_blank'>
                    <button>{t('tr.detail')}</button>
                </a>
            </td>
        </tr>
    </>
    )
}

export default Tr